<div class="main-content">
  <app-header [title]="'HEADER.TITLE_REPOSITORY' | translate" [subtitle]="'HEADER.SUBTITLE_REPOSITORY' | translate" />

  <div class="row mb-5" style="margin-top: 4.2rem">
    <div class="col-12 d-flex justify-content-end gap-3">
      <button class="req-doc-button" [routerLink]="['/repository', 'required-documents']" *appHasRole="['ADMIN']">
        {{ 'REPOSITORY.MANAGE_REQUIRED_DOC' | translate }}
      </button>
      <button class="create-odv-button" [routerLink]="['/repository', 'sales-order', 'new']" *appHasRole="['ADMIN']">
        {{ 'REPOSITORY.UPLOAD_ODV' | translate }}
      </button>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-12">
      <app-icam-container [iconName]="'repository'" [iconColor]="'white'">
        <app-table
          type="sales-order"
          [allValues$]="allSalesOrders$"
          [filters$]="salesOrderFilters$"
          [prevPage]="salesPrevPage"
          [currentPage]="salesCurrentPage"
          [nextPage]="salesNextPage"
          [totalPages]="salesTotalPages"
          (selectedFilter)="onFilterSelected($event)"
          (selectedPage)="onPageSelected($event)"
          [hasKeywordFilter]="true"
          [useInlineKeywordFilter]="true"
          [keywordFilterName]="'salesOrderNumber'"
          [keywordFilterPlaceholder]="'FILTER.SEARCH_SALES_ORDER_DOCUMENTS'"
        />
      </app-icam-container>
    </div>
  </div>
</div>
<app-footer-copyright />
